import { HttpInsuranceProductService } from './../../../../../service/http-insurance-product.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ColumnDefinitionDto } from '../../../../../service/dto';
import { HttpInsurancePolicyService } from './../../../../../service/http-insurance-policy.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finance-product-schedule-format',
  standalone: false,
  templateUrl: './finance-product-schedule-format.component.html',
  styleUrl: './finance-product-schedule-format.component.scss'
})
export class FinanceProductScheduleFormatComponent implements OnInit{
	columns:ColumnDefinitionDto[] = [];
	constructor(private service: HttpInsuranceProductService,private modalRef: NzModalRef){}

	ngOnInit(): void {
		this.service.getScheduleFormat().subscribe(result => this.columns=result);
	}

    get exampleHeader(): string {
        return this.columns.map(c => c.header).join(',');
    }
    close(): void {
        this.modalRef.close();
    }
}
